import Text from "@/components/shared/AppText";
import React from "react";
import { Pressable } from "react-native";
import tw from "twrnc";

const Link = ({ style, children, onPress }) => {
  return (
    <Pressable onPress={onPress} style={style}>
      <Text
        style={tw`text-[#e94a23] text-[14px] font-medium text-left tracking-[-0.2px] leading-[15px] mt-5`}
      >
        {children}
      </Text>
    </Pressable>
  );
};

export default Link;
